import { create } from "zustand";
import type { Vehicle } from "@/v2/apis/vehicle/vehicle-apis";

export type RentalBike = Vehicle | null;

interface RentalsState {
  rentalBike: RentalBike | null;

  setRentalBike: (bike: RentalBike | null) => void;
  clearRentalBike: () => void;
  clearRentals: () => void;
}

export const useRentalsStore = create<RentalsState>()((set) => ({
  rentalBike: null,

  setRentalBike: (bike) => set({ rentalBike: bike }),

  clearRentalBike: () => set({ rentalBike: null }),

  clearRentals: () =>
    set({
      rentalBike: null,
    }),
}));

export const useRentalBike = () => useRentalsStore((state) => state.rentalBike);
